import React, { ReactNode } from 'react';
import { Box } from '@forgeglobal/design-framework';
import {
  ApplicationInsights,
  SeverityLevel,
} from '@microsoft/applicationinsights-web';
import { boundaryStyles } from './style';
import { DefaultError } from './DefaultError';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

declare global {
  interface Window {
    appInsights: ApplicationInsights;
  }
}

export interface ErrorBoundaryProps extends WithStyles<typeof boundaryStyles> {
  children: ReactNode;
}

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    if (window && window.appInsights && window.appInsights.trackException) {
      window.appInsights.trackException({
        severityLevel: SeverityLevel.Error,
        exception: error,
        properties: errorInfo,
      });
    }
  }

  render() {
    const { classes } = this.props;
    if (this.state.hasError) {
      return (
        <div className={classes.wrapper}>
          <Box className={classes.spacer} />
          <DefaultError />
        </div>
      );
    }

    return this.props.children;
  }
}

export default withStyles(boundaryStyles)(ErrorBoundary);
